import { useGLTF } from '@react-three/drei'
import { configuratorBuilder, mapPublishedRevisionDataHandler } from 'higgins-domain'
import { createI18n } from 'higgins-i18n'

import { mountApplication } from '@salsita-ai/platform-project-sdk/application'

import { customAdminOptics } from './admin/admin-components.js'
import { appEnvironmentElement } from './elements/AppEnvironment.js'
import { notAuthorizedAdminPageElement } from './elements/NotAuthorizedAdminPage.js'
import { sceneComponents } from './entity-components/scene.js'
import { segmentComponents } from './entity-components/segment.js'
import { getApplicationWrapperHandler } from './handlers/get-application-wrapper.js'
import { getWebComponentOptionsHandler } from './handlers/get-web-component-options.js'
import {
  createMatchingCountertop,
  deleteMatchingCountertop,
  onBaseCabinetDeleted,
  selectBaseCabinetOnCountertopSelected,
  slideSegmentsOnDeletion,
  slideSegmentsOnSegment24To36,
  slideSegmentsOnSegment36To24,
} from './systems/transformers.js'
import { themeOptions } from './theme.js'

useGLTF.preload(`${phoenix.runtimeConfig.RESOURCES_URL}/models/higgins.glb`)

const config = configuratorBuilder
  .withComponentOptics([...sceneComponents, ...segmentComponents])
  .withAdminComponentOptics(customAdminOptics)
  .withHandlers([getApplicationWrapperHandler, getWebComponentOptionsHandler, mapPublishedRevisionDataHandler])
  .withElements([appEnvironmentElement, notAuthorizedAdminPageElement])
  .withWebComponentTag('salsita-configurator')
  .withDefaultEnvs({
    deploymentId: phoenix.runtimeConfig.DEPLOYMENT_ID,
    persistenceMode: phoenix.runtimeConfig.USE_LOCAL_STORAGE_CLIENT ? 'local-storage' : 'server',
    serverUrl: phoenix.runtimeConfig.SERVER_URL,
    resourcesUrl: phoenix.runtimeConfig.RESOURCES_URL,
    datadogEnabled: phoenix.runtimeConfig.DATADOG_ENABLED,
    datadogSite: phoenix.runtimeConfig.DATADOG_SITE,
    datadogClientToken: phoenix.runtimeConfig.DATADOG_CLIENT_TOKEN,
    serviceName: phoenix.runtimeConfig.SERVICE_NAME,
    gtmId: phoenix.runtimeConfig.GTM_ID,
    gtmDebug: phoenix.runtimeConfig.GTM_DEBUG,
  })
  .withI18n(createI18n())
  .withTheme(themeOptions)
  .withTransformers(
    [
      { name: 'onBaseCabinetDeleted', transformer: onBaseCabinetDeleted },
      { name: 'deleteMatchingCountertop', transformer: deleteMatchingCountertop },
      { name: 'createMatchingCountertop', transformer: createMatchingCountertop },
      { name: 'slideSegmentsOnDeletion', transformer: slideSegmentsOnDeletion },
      { name: 'selectBaseCabinetOnCountertopSelected', transformer: selectBaseCabinetOnCountertopSelected },
      { name: 'slideSegmentsOnSegment24To36', transformer: slideSegmentsOnSegment24To36 },
      { name: 'slideSegmentsOnSegment36To24', transformer: slideSegmentsOnSegment36To24 },
    ],
    [
      { name: 'OnBaseCabinetDeleted' },
      { name: 'DeleteMatchingCountertop' },
      { name: 'CreateMatchingCountertop' },
      { name: 'SlideSegmentsOnDeletion' },
      { name: 'SelectBaseCabinetOnCountertopSelected' },
      { name: 'SlideSegmentsOnSegment24To36' },
      { name: 'SlideSegmentsOnSegment36To24' },
    ]
  )
  .buildConfig()

mountApplication(config)
